<template>
  <div
    class="song-card"
    :class="{
      [`${type}`]: true,
      custom: !isSelf,
      public: [1, 3].includes(data.publish_state),
      'custom-video': !isSelf && !data?.video?.video_url,
    }"
  >
    <AudioPlayer
      class="flex-row-top"
      :class="`${type}`"
      ref="refPlayer"
      :url="renderData.url"
      :duration="renderData.duration"
      @syncPlayState="syncPlayState"
      @syncLoadingState="syncLoadingState"
      @syncProgress="syncProgress"
      @curPlayEnded="onCurPlayEnded"
    >
      <div
        class="cover"
        :class="{
          'cover-disabled': isSelf && isDisableByAudit,
        }"
      >
        <img
          v-if="data?.cover"
          :src="getObjectStorageFullUrl(data?.cover)"
          alt=""
          class="cover-img"
          :class="[1, 3].includes(data.publish_state) ? '' : 'edit-img'"
        />
        <img
          v-else
          src="@/assets/img/default-cover-3x.png"
          alt=""
          class="cover-img"
          :class="[
            `${type}`,
            [1, 3].includes(data.publish_state) ? '' : 'edit-img',
          ]"
        />
        <div class="edit-cover" @click="onChangeCover">
          <img class="edit-icon" src="@/assets/img/release/edit_pen.png" />
          <span>{{ $$t("editor.edit_image") }}</span>
        </div>
        <div v-if="type === 'release'" class="release-info">
          <div class="dur-time">
            {{ mediaUtil.formatTime(renderData.duration) }}
          </div>
          <div class="cover-play-icon"></div>
        </div>
      </div>
      <div class="title-box">
        <div class="title-wrapper flex">
          <h1 class="title olh" @click="handleDetail">
            {{ data.title }}
          </h1>
        </div>
        <div class="title-box-status">
          <div
            class="song-edit-model-status"
            v-if="data?.model"
            :class="data?.model?.split(' ').pop()"
          >
            {{ data?.model?.split(" ").pop() }}
          </div>
          <div class="publish-status" v-if="data.publish_state === 1 && isSelf">
            <div class="publish-status-text">
              {{ $t("create.published") }}
            </div>
            <div class="publish-status-border"></div>
          </div>
          <div
            class="song-edit-upload-status"
            v-if="isSelf && data.is_generated_from_uploaded_file"
          >
            {{ $$t("editor.uploaded") }}
          </div>
          <div
            class="song-edit-type-status"
            v-if="isSelf && getEditorType(data)"
          >
            {{ getEditorType(data) }}
          </div>

          <!-- <div class="song-edit-type-status" v-if="data.is_trimmed">
            {{ $$t("editor.trim") }}
          </div> -->
          <!-- <img class="publish-icon" src="@/assets/img/store/published.webp" /> -->
        </div>
        <div
          class="tag olh"
          v-if="
            !props.isGenerating &&
            (data?.description?.trim() ||
              (!data?.description &&
                combineStrings(
                  data?.genre ?? data?.genres,
                  data?.mood ?? data?.moods
                )))
          "
        >
          <span class="rotate-loading block" v-if="props.isGenerating"> </span>
          <span v-if="!props.isGenerating && !data?.description">
            {{
              combineStrings(
                data?.genre ?? data?.genres,
                data?.mood ?? data?.moods
              )
            }}
          </span>
          <span
            class="tag-tag-box fn-inline olh"
            v-if="!props.isGenerating && data?.description?.trim()"
          >
            {{ data?.description }}
          </span>
        </div>
        <div class="nickname olh">
          <img
            class="avatar"
            :src="getObjectStorageFullUrl(data?.user?.profile_image)"
          />{{ data?.user?.stage_name }}
        </div>
        <div class="gen-date">
          <span class="fn-inline" v-if="data?.publish_at">
            {{ formatDate(data?.publish_at * 1000, "YYYY-MM-DD") }}｜
          </span>
          <span class="fn-inline" v-if="!data?.publish_at && data?.generate_at">
            {{ formatDate(data?.generate_at * 1000, "YYYY-MM-DD hh:mm") }}｜
          </span>
          <i v-if="data?.play_count" class="ico play-count fn-inline"></i>
          <span v-if="data?.play_count" class="fn-inline play-count-num">
            {{ formatNumberRound(data?.play_count) }}｜
          </span>
          <span class="fn-inline">
            {{
              props.isGenerating
                ? "--:--"
                : mediaUtil.formatTime(data?.duration_milliseconds / 1000)
            }}
          </span>
        </div>
        <div class="use-box flex-row-center">
          <div class="play-icon flex-center">
            <div class="audio-item-op-box fn-inline pointer">
              <div
                class="audio-item-op flex-center"
                :class="`${type}`"
                @click.stop="doTogglePlay"
              >
                <i
                  class="block"
                  :class="{
                    'isplay-true': !renderData.isplay,
                    'isplay-false': renderData.isplay,
                  }"
                ></i>
              </div>
            </div>
          </div>
          <AudioItem
            :item="renderData.item"
            :pitem="renderData.pitem"
            :isSelf="isSelf"
            @like="
              (pitem, item) => $emit('changeFavorite', item.is_liked ? 1 : 2)
            "
            @share="() => $emit('share')"
            renderType="createdetail"
            @doPlayVideo="doPlayVideo"
            @delete="deleteSong"
            @handleSimilar="handleSimilar"
          />

          <!-- <Bubble
            :content="!renderData.isplay ? $t('store.play') : $t('store.pause')"
          >
            <div class="play-icon flex-center">
              <div class="audio-item-op-box fn-inline pointer">
                <div
                  class="audio-item-op flex-center"
                  @click.stop="doTogglePlay"
                >
                  <i
                    class="block"
                    :class="{
                      'isplay-true': !renderData.isplay,
                      'isplay-false': renderData.isplay,
                    }"
                  ></i>
                </div>
              </div>
            </div>
          </Bubble>
          <Bubble
            :content="
              data.is_liked == true ? $t('store.like') : $t('store.unlike')
            "
          >
            <div
              class="icon pointer"
              @click="handleLike"
              :class="data.machine_state == 4 ? 'op' : ''"
            >
              <img
                v-if="!data.is_liked"
                src="@/assets/img/like.png"
                alt=""
              />
              <img
                v-if="data.is_liked"
                src="@/assets/img/like-ico.png"
                alt=""
              />
            </div>
          </Bubble>
          <Bubble
            :content="$t('store.copyLink')"
            v-model:successContent="successText"
          >
            <div
              class="icon pointer"
              @click="handleShare"
              :class="data.machine_state == 4 ? 'op' : ''"
            >
              <img src="@/assets/img/share.png" alt="" />
            </div>
          </Bubble>
          <div class="content-box">
            <div
              class="icon report-icon"
              v-if="
                data.sold_state == 1 &&
                data.audit_state == 1 &&
                $$language() == 'cn'
              "
            >
              <Report
                :songId="data.song_id"
                @handleReport="handleReport"
              ></Report>
            </div>
          </div> -->
        </div>
      </div>
    </AudioPlayer>
    <ReportDialog
      v-if="reportDialogVisible"
      v-model:visible="reportDialogVisible"
      :data="data"
      :reportType="4"
    ></ReportDialog>
    <input
      type="file"
      ref="file"
      accept="image/*"
      @change="onFileChange"
      style="display: none"
    />
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  reactive,
  getCurrentInstance,
  watch,
} from "vue";
import constTags from "@/config/const.js";

import { useRouter, useRoute } from "vue-router";
import Bubble from "@/components/bubble/bubble.vue";
import Report from "@/components/report/report.vue";
import { copyToClipboard, formatNumberRound } from "@/utils/tools";
import useShopCartStore from "@/store/shopCartStore.js";
import useUserDataStore from "@/store/userDataStore";
import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";
import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue";
import mediaUtil from "@/components/media/utils/utils.js";
import { favoriteSong } from "@/api/api/apiStore.js";
import message from "@/components/functionCallComponent/message/message.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import config, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config";
import GlobalAudioPlayer from "@/components/media/audioPlayer/GlobalAudioPlayer.js";
import { $$t, $$language } from "@/i18n/i18n";
import ReportDialog from "@/components/report/reportDialog.vue";
import { formatDate } from "@/utils/dateTime.js";
import AudioItem from "@/page/create/feedList/audioItem.vue";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";

const shopCartStore = useShopCartStore();
const userDataStore = useUserDataStore();
const feedListDataStore = useFeedListStore();
const globalPlayDataStore = useGlobalPlayDataStore();
const Router = useRouter();
const route = useRoute();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;

const reportDialogVisible = ref(false);
const file = ref(null);

const isDisableByAudit = computed(() => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4, 5].includes(renderData.item?.machine_audit_state) ||
    renderData.pitem.state == 12 ||
    (config.appname == chinaAppName && renderData.pitem?.state == 2)
  );
});

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: "",
  },
  audioUrlSuffix: {
    type: String,
    default: "",
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
});

const refPlayer = ref(null);

const init = (data) => {
  data = data ?? props.data;
  renderData.url = getAudioUrl();
  renderData.isCurPlay = GlobalAudioPlayer.currentUrl == renderData.url;
  renderData.duration = (data?.duration_milliseconds ?? 0) / 1000;
  renderData.item = data;
  renderData.pitem = {
    feed_id: data?.feed_id,
    songs: [data],
    is_generated_from_uploaded_file: data?.is_generated_from_uploaded_file,
    generation_method: data?.generation_method,
    model: data?.model,
    is_trimmed: data?.is_trimmed,
    state: data?.pstate,
    thinking_process_url: data?.thinking_process_url,
  };
};

const editTypeMap = {
  // 1 song 2-延长  3-编辑  5 翻唱 6 分轨, 7-bgm, 8-翻译
  // 1: $$t("editor.song"),
  2: $$t("editor.extend_editing"),
  3: $$t("editor.region_editing"),
  5: $$t("editor.cover_voice"),
  6: $$t("editor.track_stem"),
  // 7: $$t("editor.bgm"),
  8: $$t("editor.lyrics_translate"),
  //9: $$t("editor.trim"),
};

const getEditorType = (item) => {
  if (item.is_trimmed) {
    return $$t("editor.trim");
  }
  return editTypeMap[item.generation_method];
};

watch(
  () => {
    return props.data;
  },
  () => {
    console.log("props.data", props.data);
    init();
  }
);

watch(
  () => {
    return globalPlayDataStore.curPlayData;
  },
  () => {
    if (globalPlayDataStore.curPlayData?.feed_id == props.data?.feed_id) {
      renderData.url = getAudioUrl();
    }
  }
);

const getAudioUrl = () => {
  if (
    (props.data?.stream_key &&
      GlobalAudioPlayer.currentUrl ==
        getPipeReadableFlowUrl(props.data?.stream_key) &&
      GlobalAudioPlayer.players[GlobalAudioPlayer.currentUrl]?.isPlaying) ||
    !props.data?.mp3_url
  ) {
    return getPipeReadableFlowUrl(props.data?.stream_key);
  } else {
    return getObjectStorageFullUrl(props.data?.mp3_url);
  }
};
const renderData = reactive({
  url: getAudioUrl(),
  duration: (props.data?.duration_milliseconds ?? 0) / 1000,
  isplay: false,
  buffer: false,
  progress: 0,
  isCurPlay: false,
  item: props.data,
  pitem: {
    feed_id: props.data?.feed_id,
    songs: [props.data],
    is_generated_from_uploaded_file:
      props.data?.is_generated_from_uploaded_file,
    generation_method: props.data?.generation_method,
    model: props.data?.model,
    state: props.data?.pstate,
    is_trimmed: props.data?.is_trimmed,
    thinking_process_url: props.data?.thinking_process_url,
  },
});
const successText = ref("");

const isSelf = computed(() => {
  const { data } = props;
  const isUserDataUser = userDataStore.userInfo?.user?.user_id;
  const isDataUser = data?.user?.user_id;
  return isUserDataUser && isUserDataUser === isDataUser;
});

const emits = defineEmits([
  "togglePlay",
  "addCartSuccess",
  "addCartFail",
  "changeFavorite",
  "changeSaleState",
  "progress",
  "share",
  "handleSimilar",
  "deleteSong",
]);

const deleteSong = () => {
  emits("deleteSong");
};

const doPlayVideo = () => {
  globalProperties.logClickEvent("song_detail_page_video", {
    type: isSelf.value ? "active_state " : "passive_state",
  });
};

const syncPlayState = (playState) => {
  console.log("syncPlayState🍎🍎🍎", playState);
  renderData.isplay = playState;
  if (renderData.isplay) {
    if (!renderData.hasPlayed && userDataStore.isLogin) {
      feedListDataStore.doReportPlayedState({}, props.data).then(() => {
        renderData.hasPlayed = true;
      });
    }
    // feedListDataStore.doPlayStateReport({}, props.data, 1);
  }
};

const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
};

const syncProgress = (progress) => {
  renderData.progress = progress;
  emits("progress", progress);
};

const onCurPlayEnded = () => {
  // feedListDataStore.doPlayStateReport(proprenderData.item, 2);
};

const doTogglePlay = () => {
  refPlayer.value?.changeOp();
  nextTick().then(() => {
    emits("togglePlay", renderData.isplay);
  });
};

const combineStrings = (str1, str2) => {
  // if (![1, 3].includes(props.data?.publish_state)) {
  if (!(Array.isArray(str1) && Array.isArray(str2))) return;
  if (str1 && str2) {
    return `${str1.join(" ")} | ${str2.join(" ")}`;
  }
  return str1?.join(" ") || str2?.join(" ");
  // } else {
  //   // str1 =>genres str2 => moods
  //   const genres = constTags.getRenderLabel(str1, constTags.StyleLabelData.map);
  //   const moods = constTags.getRenderLabel(
  //     str2,
  //     constTags.EmotionalLabelData.map
  //   );
  //   if (genres?.length && moods?.length) {
  //     return `${genres.join(" ")} | ${moods.join(" ")}`;
  //   } else if (genres?.length) {
  //     return genres.join(" ");
  //   } else if (moods?.length) {
  //     return moods.join(" ");
  //   } else {
  //     return "";
  //   }
  // }
};

const handleSimilar = () => {
  emits("handleSimilar", props.data);
};

// 进入详情
const handleDetail = () => {
  const { song_id } = props.data;
  Router.push({
    name: "songDetail",
    query: {
      source: pageenum?.[props?.type] ?? "store",
    },
    params: {
      song_id,
    },
  });
};

const pageenum = {
  detail: "song_detail_page",
  liked: "liked_songs_page",
  release: "release_page",
};

// 分享复制链接
const handleShare = async () => {
  if (props.data.machine_state == 4) {
    return;
  }
  globalProperties.logClickEvent("song_copy_link", {
    content_id: props.data?.song_id ?? props.data?.song?.song_id ?? "",
    source:
      route?.query?.is_from_share == 1
        ? "song_share_page"
        : pageenum?.[props.type] ?? "store",
  });
  const { song_id, share_key } = props.data;
  copyToClipboard(
    `${config.baseOrigin}/song-detail/${share_key}?is_from_share=1`
  ).then((res) => {
    successText.value = $$t("store.copyLinkSuccess");
  });
  shopCartStore
    .getShareKey(
      song_id,
      `${config.baseOrigin}/song-detail/${share_key}?is_from_share=1`
    )
    .then((res) => {});
};

// 点赞
const handleLike = async () => {
  if (!(await userDataStore.checkLoginStatus())) {
    return;
  }
  if (props.data.machine_state == 4) {
    return;
  }
  const { is_liked, song_id } = props.data;
  favoriteSong({
    song_id: song_id,
    state: !is_liked ? 1 : 0,
  }).then((res) => {
    if (res.code == 200) {
      emits("changeFavorite", !is_liked ? 2 : 1);
    }
  });
};

const changeUrlListenerListener = () => {
  renderData.isCurPlay =
    GlobalAudioPlayer.currentUrl ==
    getObjectStorageFullUrl(props.data?.song_url);
};

onMounted(() => {
  GlobalAudioPlayer.registGlobleListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
});

onUnmounted(() => {
  GlobalAudioPlayer.releaseGlobleListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
});

const onChangeCover = () => {
  if (!isSelf.value) {
    return;
  }
  // 清除之前的文件
  file.value.value = "";
  file.value.click();
};

const checkFile = (file) => {
  const maxSize = 10 * 1024 * 1024; // 10MB
  const allowedSizes = [
    { width: 3000, height: 3000 },
    { width: 1440, height: 1440 },
  ];

  return new Promise((resolve, reject) => {
    if (file.size > maxSize) {
      reject("File size must be no larger than 10MB.");
      return;
    }
    resolve("File is valid");

    // const img = new Image();
    // img.onload = () => {
    //   const isValidSize = allowedSizes.some(
    //     (size) => img.width === size.width && img.height === size.height
    //   );

    //   if (!isValidSize) {
    //     reject("Image size must be 3000x3000 or 1440x1440.");
    //   } else {
    //     resolve("File is valid");
    //   }
    // };

    // img.onerror = () => {
    //   reject("Invalid image file.");
    // };

    // img.src = URL.createObjectURL(file);
  });
};

const onFileChange = async (e) => {
  const file = e.target.files[0];
  try {
    const res = await checkFile(file);
    console.log("before", props.data.cover);
    feedListDataStore.doSureToSaveSongInfo(
      {},
      props.data,
      {
        file,
      },
      {
        song_id: props.data.song_id,
        title: props.data.title,
      }
    );
  } catch (error) {
    message.error({
      position: "top",
      content: error,
    });
  }
};
</script>

<style lang="scss" scoped>
.song-card {
  font-family: HarmonyOS Sans SC;
  padding: 12px 24px 12px 16px;
  // border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  &-active {
    background: rgba(118, 255, 232, 0.2);
    &:hover {
      background: rgba(118, 255, 232, 0.3);
    }
  }
  &-normal {
    // &:hover {
    //   background: rgba(255, 255, 255, 0.1);
    // }
  }

  :deep(.audio-item-createdetail-btns) {
    gap: 8px;

    .audio-item-createdetail-btn {
      width: 44px;
      height: 44px;
      i.block {
        width: 24px;
        height: 24px;
      }
    }

    .audio-item-publish-btn {
      margin: 0 8px;
    }
  }
  &.custom-video {
    :deep(.audio-item-createdetail-btns) {
      .audio-item-createdetail-btn-video {
        display: none;
      }
    }
  }

  &.custom {
    :deep(.audio-item-createdetail-btns) {
      .audio-item-publish-btn,
      .audio-item-createdetail-btn-download {
        display: none;
      }
    }
    .cover {
      &:hover {
        .edit-cover {
          display: none;
        }
      }
    }
  }

  &.public,
  &.release {
    .cover {
      &:hover {
        .edit-cover {
          display: none;
        }
      }
    }
  }

  &.release {
    .use-box {
      margin-left: 15px;
    }
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 380px;

      position: absolute;
      top: 40px;
      left: 0;
      z-index: 1;
      background: transparent;
    }
  }

  .cover {
    position: relative;
    border-radius: 8px;
    .cover-img {
      display: block;
      width: 268px;
      height: 268px;
      border-radius: 8px;
      &.release {
        width: 203px;
        height: 203px;
        border-radius: 8px;
      }
    }
    .edit-cover {
      display: none;
    }

    &:hover {
      .edit-img {
        opacity: 0.5;
      }
      .edit-cover {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 8px;
        background: rgba(0, 0, 0, 0.1);
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .edit-icon {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
      }
    }

    &.cover-disabled {
      .edit-img {
        opacity: 1;
      }
      .edit-cover {
        display: none;
      }
      &:hover {
        .edit-img {
          opacity: 1;
        }
      }
    }

    .release-info {
      display: none;
    }
  }

  .time {
    padding: 6px 9px;
    font-size: 14px;
    font-weight: normal;
    line-height: 16px;
    color: #ffffff;
    border-radius: 8px;
    position: absolute;
    bottom: 8px;
    left: 8px;

    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
  }

  .play-icon {
    width: 48px;
    height: 48px;
    // margin-right: 16px;
    .audio-item-op {
      width: 48px;
      height: 48px;
      border-radius: 28px;
      /* border: 1px solid #ffffff; */
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
      i {
        height: 48px;
        width: 48px;
        &:hover {
          opacity: 0.8;
        }
      }
      .isplay-true {
        background: url("@/assets/img/release/play-light-ico.png");
        background-size: 100% 100%;
      }
      .isplay-false {
        background: url("@/assets/img/release/pause-light-ico.png");
        background-size: 100% 100%;
      }
      &.release {
        margin-right: 20px;
        i {
          height: 36px;
          width: 36px;

          background: url("@/assets/img/release/play-circle-release.png");
          background-size: 100% 100%;
        }
      }
    }
  }
  .title-box {
    min-width: 0;
    .title-wrapper {
      display: flex;
      align-items: center;
      .title {
        flex: 1 1 0 !important;
      }
    }
    .title-box-status {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
    .publish-status {
      cursor: pointer;
      width: max-content;
      position: relative;
      margin: 0 4px 0 0;

      .publish-status-border {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        border-radius: 2px;
        padding: 1px;
        background: rgba(255, 255, 255, 0.5);
        mask: linear-gradient(#fff 0 0) content-box,
          linear-gradient(#fff 0 0) border-box;
        mask-composite: exclude;
      }

      .publish-status-text {
        font-family: HarmonyOS Sans SC;
        font-size: 10px;
        font-weight: normal;
        line-height: 18px;
        text-align: center;
        background: rgba(255, 255, 255, 0.5);
        background-clip: text;
        color: transparent;
        padding: 0 6px;
      }
    }
    .song-edit-model-status,
    .song-edit-type-status,
    .song-edit-upload-status {
      height: 18px;
      font-family: HarmonyOS Sans SC;
      font-size: 10px;
      font-weight: normal;
      line-height: 16px;
      text-align: center;
      border: 1px solid rgba(255, 255, 255, 0.5);
      border-radius: 2px;
      padding: 0 4px;
      color: rgba(255, 255, 255, 0.5);
      margin: 0 4px 0 0;
    }
    .song-edit-model-status {
      background: linear-gradient(
        122deg,
        #000000 10%,
        rgba(104, 31, 159, 0.7) 50%,
        #000000 89%
      );
      border: 1px solid rgba(165, 70, 220, 0.8);
      color: #fac9ff;
      backdrop-filter: blur(12px);
      opacity: 1;
      font-size: 11px;
      padding: 0 6px;
      &.O1 {
        background: linear-gradient(
          122deg,
          #000000 8%,
          #6a6112 47%,
          #000000 91%
        ) !important;
        border: 1px solid rgba(255, 241, 114, 0.8) !important;
        color: #fffc35;
        backdrop-filter: blur(12px);
      }
    }
    .publish-icon {
      min-width: 62px;
      width: 62px;
    }
    .title {
      display: inline-block;
      user-select: text;
      font-size: 16px;
      font-weight: 800;
      line-height: 24px;
      // &:hover {
      //   @include green_text_color;
      // }
    }
    .nickname {
      display: flex;
      align-items: center;
      margin-top: 4px;
      font-size: 12px;
      line-height: 16px;
      color: #ffffff60;
      .avatar {
        margin-right: 10px;
        border-radius: 50%;
        height: 24px;
        width: 24px;
      }
    }
    .tag {
      text-transform: capitalize;
      height: 16px;
      color: #ffffff;
      opacity: 0.5;
      font-size: 14px;
      line-height: 16px;
    }
    .tag-tag-box {
      max-width: 500px;
    }
    .gen-date {
      margin-top: 8px;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff60;
    }
    .play-count {
      height: 16px;
      width: 16px;
      margin: 0 4px 0 0;
      background: url("@/assets/img/store/listen.png");
      background-size: 100% 100%;
      opacity: 0.5;
    }
    .rotate-loading {
      width: 16px;
      height: 16px;
      background: url("@/assets/img/loading-mini-white-3x.png");
      background-size: 100% 100%;
      display: inline-block;
    }
  }
  .wave-box {
    width: 40%;
    margin-right: 20px;

    .wave {
      width: 100%;
      height: 28px;

      // .audio-waveform {
      //   background: red;
      //   .audio-waveform-op-progress {

      //   }
      // }
    }
  }
  .use-box {
    flex: 1;
    gap: 12px;
    .content-box {
      margin-left: 18px;
      width: 40px;
      height: 40px;
    }
    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 16px;
      width: 40px;
      height: 40px;
      &:hover {
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.1);
      }
      img {
        width: 24px;
        height: 24px;
      }
    }

    .report-icon {
      // margin-right: 0px;
      // margin-left: 18px;
    }

    .op {
      opacity: 0.3;
      &:hover {
        border-radius: 0;
        background-color: transparent;
      }
    }

    .checkout-btn {
      width: 140px;
      text-align: center;
      padding: 0 10px;
      border-radius: 60px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
    .op-btn {
      opacity: 0.3;
    }
  }
}
@media screen and (max-width: 1000px) {
  .song-card {
    .cover {
      .cover-img {
        width: 210px;
        height: 210px;
        border-radius: 8px;
      }
    }
    &.detail {
      .title-box {
        .nickname,
        .gen-date {
          margin-top: 6px !important;
        }
      }

      .title-box {
        margin: 0 0 0 20px !important;
        height: 210px !important;
        .tag {
          margin: 4px 0;
        }
      }
      :deep(.audio-item-createdetail-btns) {
        gap: 4px !important;
      }
      .use-box {
        gap: 12px !important;
        align-items: center;
        justify-content: start;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .song-card {
    padding: 40px 40px 24px 40px;
    &.release {
      .flex-row-top {
        flex-direction: column;
      }
      .cover {
        position: relative;
        .cover-img {
          width: 180px !important;
          height: 180px !important;
        }
        .release-info {
          display: flex;
          width: 100%;
          position: absolute;
          bottom: 0;
          padding: 8px;
          justify-content: space-between;
          align-items: center;
          .dur-time {
            width: 50px;
            height: 26px;
            font-size: 12px;
            border-radius: 8px;
            font-weight: normal;
            line-height: 26px;
            text-align: center;
            background: rgba(0, 0, 0, 0.2);
            backdrop-filter: blur(10px);
            color: #ffffff;
          }
          .cover-play-icon {
            width: 48px;
            height: 48px;
            background: url("@/assets/img/release/hover@3x.png");
            background-size: 100% 100%;
            border-radius: 50%;
            backdrop-filter: blur(12px);
          }
        }
      }
      .title-box {
        width: 100%;
        margin: 0 !important;
        .title {
          font-size: 18px;
          font-weight: bold;
          line-height: 28px;
        }
        .tag {
          font-size: 12px;
          font-weight: normal;
          color: rgba(255, 255, 255, 0.8);
          opacity: 1;
        }
        .gen-date,
        .use-box {
          display: none;
        }
        .nickname {
          color: #fff;
        }
      }
    }
  }
}
</style>
